import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import Logo from './Logo';
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaPinterest,
  FaTiktok,
  FaWhatsapp,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const { settings } = useSettings();

  const socialIcons = {
    facebook: FaFacebook,
    twitter: FaTwitter,
    instagram: FaInstagram,
    linkedin: FaLinkedin,
    youtube: FaYoutube,
    pinterest: FaPinterest,
    tiktok: FaTiktok,
    whatsapp: FaWhatsapp,
  };

  return (
    <footer className="footer">
      <div className="container footer-content">
        <div className="footer-section footer-brand">
          <div className="footer-brand-row">
            <Logo variant="mark" size={42} />
            <h3>{settings?.siteName || 'Centre Techniques Pianos'}</h3>
          </div>
          <p>{settings?.siteDescription || 'Premium musical instruments and professional audio equipment for every musician.'}</p>
          {settings?.socialMedia && Object.values(settings.socialMedia).some(Boolean) && (
            <div className="social-links">
              {Object.entries(settings.socialMedia).map(([platform, url]) => {
                if (!url) return null;
                const Icon = socialIcons[platform];
                if (!Icon) return null;
                return (
                  <a
                    key={platform}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={platform}
                  >
                    <Icon />
                  </a>
                );
              })}
            </div>
          )}
        </div>

        <div className="footer-section">
          <h4>Services</h4>
          <ul>
            <li><Link to="/services#piano-sales-rentals">Piano Sales & Rentals</Link></li>
            <li><Link to="/services#piano-tuning">Tuning & Maintenance</Link></li>
            <li><Link to="/services#piano-movement">Piano Movement</Link></li>
            <li><Link to="/services#piano-repair">Repair & Restoration</Link></li>
            <li><Link to="/consultancy">Music Consultancy</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Shop</h4>
          <ul>
            <li><Link to="/products">All Products</Link></li>
            <li><Link to="/products?featured=true">Featured</Link></li>
            <li><Link to="/cart">Cart</Link></li>
            <li><Link to="/contact">Contact us</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Account</h4>
          <ul>
            <li><Link to="/login">Sign In</Link></li>
            <li><Link to="/register">Create Account</Link></li>
            <li><Link to="/profile">My Profile</Link></li>
            <li><Link to="/my-orders">Order History</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Get in touch</h4>
          <ul className="contact-list">
            {settings?.contactEmail && (
              <li>
                <FaEnvelope />
                <a href={`mailto:${settings.contactEmail}`}>{settings.contactEmail}</a>
              </li>
            )}
            {settings?.contactPhone && (
              <li>
                <FaPhoneAlt />
                <a href={`tel:${settings.contactPhone}`}>{settings.contactPhone}</a>
              </li>
            )}
            <li>
              <FaMapMarkerAlt />
              <span>10, Akinwunmi St, Yaba, Lagos</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} {settings?.siteName || 'Centre Techniques Pianos'}. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/products">Browse</Link>
            <span>·</span>
            <Link to="/login">Sign in</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
